"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _draftHelpers = require("composer-plugins/lib/draftHelpers");

var _classnames = _interopRequireDefault(require("classnames"));

var _Comment = _interopRequireDefault(require("./Comment"));

var _CommentEditor = _interopRequireDefault(require("./CommentEditor"));

var _Conversation = _interopRequireDefault(require("composer-lib/data/model/Conversation"));

var _conversationsHelpers = require("composer-lib/lib/helpers/conversationsHelpers");

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _RemoveConversation = _interopRequireDefault(require("./RemoveConversation"));

var _constants = require("composer-lib/lib/constants");

var _UIAccordionItem = _interopRequireDefault(require("UIComponents/accordion/UIAccordionItem"));

var _UIBadge = _interopRequireDefault(require("UIComponents/badge/UIBadge"));

var _Users = _interopRequireDefault(require("composer-lib/data/model/Users"));

var REMOVED_MESSAGE_VISIBLE_TIME = 2500;

function renderMessage(key) {
  return _react.default.createElement(_FormattedHTMLMessage.default, {
    message: "composer-lib.conversations." + key
  });
}

var _default = (0, _createReactClass.default)({
  displayName: "Conversation",
  propTypes: {
    conversation: _propTypes.default.instanceOf(_Conversation.default).isRequired,
    currentUserId: _propTypes.default.number.isRequired,
    deleteComment: _propTypes.default.func,
    deleteCommentId: _propTypes.default.number,
    deleteCommentStatus: _propTypes.default.string,
    deleteConversation: _propTypes.default.func,
    deleteConversationDone: _propTypes.default.func,
    deleteConversationId: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    deleteConversationStatus: _propTypes.default.string,
    highlightBodyText: _propTypes.default.func,
    highlightSummaryText: _propTypes.default.func,
    highlightTitleText: _propTypes.default.func,
    index: _propTypes.default.string.isRequired,
    open: _propTypes.default.bool,
    refetchUsers: _propTypes.default.func,
    removeHighlightedBodyText: _propTypes.default.func,
    removeHighlightedSummaryText: _propTypes.default.func,
    removeHighlightedTitleText: _propTypes.default.func,
    saveComment: _propTypes.default.func,
    setConversationOpen: _propTypes.default.func,
    setClickToHideConversationsListener: _propTypes.default.func,
    users: _propTypes.default.instanceOf(_Users.default).isRequired,
    userIsAdmin: _propTypes.default.bool
  },
  getInitialState: function getInitialState() {
    return {
      hoveredOverAccordionButton: null,
      showingDeleteConfirm: false
    };
  },
  componentDidMount: function componentDidMount() {
    if (this.props.open) {
      this.scrollToLatestComment();
    }
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    var _this = this;

    // If the delete conversation request has just finished, then we want to show the "This conversation
    // has been removed" message in place of the conversation for a few seconds before dispatching
    // an action to remove the conversation from the store, which will be reflected in the UI.
    if (this.conversationHasBeenRemoved() && !this.conversationHasBeenRemoved(prevProps)) {
      this.removeHighlight();
      setTimeout(function () {
        return _this.props.deleteConversationDone(_this.props.conversation);
      }, REMOVED_MESSAGE_VISIBLE_TIME);
    }

    if (this.props.open && this.props.conversation.comments.size > prevProps.conversation.comments.size) {
      this.scrollToLatestComment();
    }

    if (this.props.open && !prevProps.open) {
      this.scrollToLatestComment();
      this.highlightConversation();
    }

    if (!this.props.open && prevProps.open) {
      this.removeHighlight();
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    this.removeHighlight();
  },
  handleMouseEnterOpenAccordionButton: function handleMouseEnterOpenAccordionButton() {
    this.setState({
      hoveredOverAccordionButton: true
    });
  },
  handleMouseLeaveOpenAccordionButton: function handleMouseLeaveOpenAccordionButton(e) {
    var removeConversationEl = _reactDom.default.findDOMNode(this._removeConversation);

    var toElement = e.toElement ? e.toElement : e.relatedTarget;

    if (removeConversationEl && (toElement === removeConversationEl || removeConversationEl.contains(toElement))) {
      return;
    }

    this.setState({
      hoveredOverAccordionButton: false,
      showingDeleteConfirm: false
    });
  },
  conversationHasBeenRemoved: function conversationHasBeenRemoved() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
    return props.deleteConversationStatus === _constants.RequestStatus.SUCCEEDED && props.deleteConversationId === props.conversation.id;
  },
  deleteComment: function deleteComment(comment) {
    var conversation = this.props.conversation;

    if (conversation.comments.size === 1) {
      this.props.deleteConversation(conversation);
    } else {
      this.props.deleteComment(comment);
    }
  },
  postComment: function postComment(comment) {
    this.props.saveComment(comment, this.props.index, this.props.conversation);

    this._commentEditor._editor.blur();
  },
  scrollToLatestComment: function scrollToLatestComment() {
    var conversationBodyEl = _reactDom.default.findDOMNode(this._conversationBody);

    conversationBodyEl.scrollTop = conversationBodyEl.scrollHeight - conversationBodyEl.clientHeight;
  },
  afterOpenChange: function afterOpenChange(open) {
    if (open) {
      this.scrollToLatestComment();
      this.highlightConversation();
    } else {
      this.removeHighlight();
    }
  },
  onOpenChange: function onOpenChange(evt) {
    var open = evt.target.value;

    if (!open) {
      this.setState({
        hoveredOverAccordionButton: false,
        showingDeleteConfirm: false
      });
      this.props.setConversationOpen(false, this.props.conversation.id);
      return;
    }

    this.props.setConversationOpen(true, this.props.conversation.id);
  },
  highlightConversation: function highlightConversation() {
    var _this$props = this.props,
        highlightText = _this$props.conversation.highlightText,
        highlightBodyText = _this$props.highlightBodyText,
        highlightSummaryText = _this$props.highlightSummaryText,
        highlightTitleText = _this$props.highlightTitleText,
        index = _this$props.index;

    if ((0, _conversationsHelpers.correlationIdIsOnTitle)(index)) {
      highlightTitleText();
    } else if ((0, _conversationsHelpers.correlationIdIsOnSummary)(index)) {
      highlightSummaryText();
    } else {
      highlightBodyText({
        // index here in conversation is stored as correlationId, but Draft needs decoded block key to find it
        blockKey: (0, _draftHelpers.correlationIdToBlockKey)(index),
        highlightText: highlightText
      });
    }
  },
  removeHighlight: function removeHighlight() {
    var _this$props2 = this.props,
        index = _this$props2.index,
        removeHighlightedBodyText = _this$props2.removeHighlightedBodyText,
        removeHighlightedSummaryText = _this$props2.removeHighlightedSummaryText,
        removeHighlightedTitleText = _this$props2.removeHighlightedTitleText;

    if ((0, _conversationsHelpers.correlationIdIsOnTitle)(index)) {
      removeHighlightedTitleText();
    } else if ((0, _conversationsHelpers.correlationIdIsOnSummary)(index)) {
      removeHighlightedSummaryText();
    } else {
      removeHighlightedBodyText();
    }
  },
  showDeleteConfirm: function showDeleteConfirm(shouldShow) {
    this.setState({
      showingDeleteConfirm: shouldShow
    });
  },
  onMouseEnterConversation: function onMouseEnterConversation() {
    this.highlightConversation();
  },
  onMouseLeaveConversation: function onMouseLeaveConversation() {
    this.removeHighlight();
  },
  getTitle: function getTitle() {
    if (this.state.showingDeleteConfirm) {
      return _react.default.createElement(_FormattedMessage.default, {
        message: "composer-lib.conversations.remove.message"
      });
    }

    var numComments = this.props.conversation.comments.size;
    return _react.default.createElement(_FormattedMessage.default, {
      message: "composer-lib.conversations.header",
      options: {
        count: numComments
      }
    });
  },
  isOnTitleSection: function isOnTitleSection() {
    return this.props.index === (0, _draftHelpers.blockKeyToCorrelationId)(_constants.TITLE_BLOCK_KEY);
  },
  renderConversationContents: function renderConversationContents() {
    var _this2 = this;

    var _this$props3 = this.props,
        _this$props3$conversa = _this$props3.conversation,
        comments = _this$props3$conversa.comments,
        id = _this$props3$conversa.id,
        index = _this$props3.index,
        users = _this$props3.users;
    return _react.default.createElement("div", {
      className: "conversation-contents"
    }, _react.default.createElement("div", {
      ref: function ref(c) {
        return _this2._conversationBody = c;
      },
      className: "conversation-body p-top-4 p-x-4"
    }, comments.map(function (comment) {
      return _react.default.createElement(_Comment.default, {
        comment: comment,
        currentUserId: _this2.props.currentUserId,
        deleteComment: _this2.deleteComment,
        deleteCommentId: _this2.props.deleteCommentId,
        deleteCommentStatus: _this2.props.deleteCommentStatus,
        deletingConversation: _this2.props.deleteConversationId === id,
        index: index,
        key: comment.id,
        users: users
      });
    })), _react.default.createElement(_CommentEditor.default, {
      commentCount: comments.size,
      externalMentionsEnabled: this.props.userIsAdmin,
      refetchUsers: this.props.refetchUsers,
      scrollToLatestComment: this.scrollToLatestComment,
      postComment: this.postComment,
      ref: function ref(c) {
        return _this2._commentEditor = c;
      },
      setClickToHideConversationsListener: this.props.setClickToHideConversationsListener,
      users: users
    }));
  },
  renderRemoveConversation: function renderRemoveConversation() {
    var _this3 = this;

    if (!this.state.hoveredOverAccordionButton) {
      return null;
    }

    var id = this.props.conversation.id;
    return _react.default.createElement(_RemoveConversation.default, {
      ref: function ref(c) {
        return _this3._removeConversation = c;
      },
      conversation: this.props.conversation,
      deleteConversation: this.props.deleteConversation,
      deleting: this.props.deleteConversationStatus === _constants.RequestStatus.PENDING && this.props.deleteConversationId === id,
      isPendingConversation: this.props.conversation.comments.size === 0,
      removeConversation: this.removeConversation,
      showDeleteConfirm: this.showDeleteConfirm
    });
  },
  renderUnreadIndicator: function renderUnreadIndicator() {
    var updates = this.props.conversation.updates;

    if (this.state.hoveredOverAccordionButton) {
      return null;
    }

    if (updates < 1) {
      return null;
    }

    return _react.default.createElement(_UIBadge.default, {
      className: "unread-indicator",
      use: "count"
    }, updates);
  },
  renderContents: function renderContents() {
    var open = this.props.open;
    var classes = (0, _classnames.default)({
      conversation: true,
      'conversation-expanded': open
    });
    return _react.default.createElement("div", {
      className: "conversation-container",
      onMouseEnter: this.onMouseEnterConversation,
      onMouseLeave: this.onMouseLeaveConversation
    }, _react.default.createElement(_UIAccordionItem.default, {
      onMouseEnter: this.handleMouseEnterOpenAccordionButton,
      onMouseLeave: this.handleMouseLeaveOpenAccordionButton,
      className: classes,
      contentClassName: "p-all-0",
      open: open,
      onOpenChange: this.onOpenChange,
      title: this.getTitle()
    }, this.renderIntroCopy(), this.renderConversationContents(), this.renderRemoveConversation()), this.renderUnreadIndicator());
  },
  renderIntroCopy: function renderIntroCopy() {
    var conversation = this.props.conversation;

    if (!conversation.get('isEmptyDummy')) {
      return null;
    }

    return _react.default.createElement("div", {
      className: "p-x-4"
    }, renderMessage('introCopy'));
  },
  renderSeparator: function renderSeparator() {
    return _react.default.createElement("div", {
      className: "conversation-separator"
    });
  },
  renderRemoved: function renderRemoved() {
    return _react.default.createElement("div", {
      className: "conversation-removed-message"
    }, renderMessage('removed'));
  },
  render: function render() {
    return _react.default.createElement("div", {
      className: "conversation-wrapper"
    }, this.renderSeparator(), this.conversationHasBeenRemoved() ? this.renderRemoved() : this.renderContents());
  }
});

exports.default = _default;
module.exports = exports.default;